'use strict';

var React = require('react');
var styled = require('styled-components');
var SpriteIconWeb = require('@swiggy-private/dls-web-food-icons/dist/SpriteIconWeb');
var SpriteIconWeb$1 = require('@swiggy-private/dls-web-icons/dist/SpriteIconWeb');
var useWindowSize = require('@swiggy-private/dls-web-common/dist/hooks/use-window-size');
var useScrollPosition = require('@swiggy-private/dls-web-common/dist/hooks/use-scroll-position');
var Dropdown = require('@swiggy-private/dls-web-core/dist/components/Dropdown');
var jsUtils = require('@swiggy-private/js-utils');
var components_DietFilterToggle_types = require('./types.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Container = styled__default.default.div(({ theme, checked, hasMoreOptions, vegOption }) => {
    const background = checked && vegOption === components_DietFilterToggle_types.VegOptionsType.VEG_EGG
        ? theme.colors[theme.colorMode].background_Secondary
        : theme.colors[theme.colorMode].background_Primary;
    const border = checked && vegOption === components_DietFilterToggle_types.VegOptionsType.VEG_EGG
        ? theme.colors[theme.colorMode].border_Primary
        : theme.colors[theme.colorMode].border_Secondary;
    return {
        display: "flex",
        width: "auto",
        alignItems: "center",
        borderRadius: `${theme.cornerRadius.halfRounded}`,
        backgroundColor: background,
        border: `1px solid ${border}`,
        padding: `0 ${theme.spacing.medium}`,
        height: "34px",
        transition: "max-width 0.25s ease-in-out",
        maxWidth: checked && hasMoreOptions ? "104px" : "72px",
    };
});
const SliderWrapper = styled__default.default.label `
    position: relative;
    display: inline-block;
    width: 38px;
    height: 10px;
`;
const Input = styled__default.default.input `
    opacity: 0;
    width: 0;
    height: 0;
`;
const Slider = styled__default.default.span(({ theme, checked, type }) => {
    const sliderColor = type === components_DietFilterToggle_types.DietType.VEG
        ? theme.colors[theme.colorMode].positive
        : theme.colors[theme.colorMode].negative;
    return {
        position: "absolute",
        cursor: "pointer",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        backgroundColor: checked
            ? sliderColor
            : theme.colors[theme.colorMode].background_Overlay_Light,
        transition: "0.25s",
        borderRadius: theme.cornerRadius.medium,
    };
});
const ToggleIcon = styled__default.default.div(({ theme, checked, vegOption }) => {
    const background = vegOption === components_DietFilterToggle_types.VegOptionsType.VEG_EGG
        ? theme.colors[theme.colorMode].background_Secondary
        : theme.colors[theme.colorMode].background_Primary;
    return {
        position: "absolute",
        content: "",
        height: "20px",
        width: "20px",
        bottom: "-5px",
        backgroundColor: background,
        transition: "0.25s",
        transform: checked ? "translateX(18px)" : "none",
    };
});
const MoreOptionsContainer = styled__default.default.button `
    display: flex;
    align-items: center;
    outline: 0;
    background: transparent;
    border: 0;
    padding: 0;
    margin: 0;
`;
const Separator = styled__default.default.div(({ theme }) => ({
    height: theme.spacing.large,
    width: "1px",
    backgroundColor: theme.colors[theme.colorMode].border_Secondary,
    margin: `0 10px 0 10px`,
}));

const VEG_OPTIONS = [
    {
        label: "Pure Veg",
        value: components_DietFilterToggle_types.VegOptionsType.VEG,
    },
];
const VEG_EGG_OPTIONS = [
    {
        label: "Pure Veg",
        value: components_DietFilterToggle_types.VegOptionsType.VEG,
    },
    {
        label: "Veg & Egg",
        value: components_DietFilterToggle_types.VegOptionsType.VEG_EGG,
    },
];
const dropDownWidth = 184;
const ACCESSIBILITY_LABEL = {
    VEG: "veg",
    VEG_EGG: "veg and egg",
    ENABLE_VEG: "Enable veg option",
    DISABLE_VEG: "Disable {0} option",
    ENABLE_NON_VEG: "Enable non veg option",
    DISABLE_NON_VEG: "Disable non veg option",
};

const DietFilterToggle = ({ type, isSelected, selectedVegOption, onChange, onSelectOption, dropDownRoot, showOnlyVeg = false, }) => {
    const theme = styled.useTheme();
    const windowSize = useWindowSize.useWindowSize();
    const scrollPosition = useScrollPosition.useScrollPosition();
    const [vegOption, setVegOption] = React.useState(selectedVegOption || components_DietFilterToggle_types.VegOptionsType.VEG);
    const [showMoreOptions, setShowMoreOptions] = React.useState(false);
    const [dropdownPosition, setDropdownPosition] = React.useState([-1000, -1000]);
    const hasMoreOptions = React.useMemo(() => type === components_DietFilterToggle_types.DietType.VEG, [type]);
    const IconName = React.useMemo(() => {
        return type === components_DietFilterToggle_types.DietType.VEG ? "vegVeg20" : "nonvegNonVeg20";
    }, [type]);
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        if (containerRef.current) {
            setDropdownPosition([
                containerRef.current.getBoundingClientRect().top,
                containerRef.current.getBoundingClientRect().left,
            ]);
        }
    }, []);
    React.useEffect(() => {
        if (containerRef.current && showMoreOptions) {
            setDropdownPosition([
                containerRef.current.getBoundingClientRect().top,
                containerRef.current.getBoundingClientRect().left,
            ]);
        }
    }, [windowSize, scrollPosition, showMoreOptions]);
    const onChangeHandler = () => {
        setVegOption(components_DietFilterToggle_types.VegOptionsType.VEG);
        onChange(!isSelected);
    };
    const moreOptionsOpenHandler = () => {
        setShowMoreOptions(true);
    };
    const moreOptionsCloseHandler = () => {
        setShowMoreOptions(false);
    };
    const moreOptionsOnChangeHandler = (e) => {
        const target = e.target;
        setVegOption(target.value);
        onSelectOption === null || onSelectOption === void 0 ? void 0 : onSelectOption(target.value);
        moreOptionsCloseHandler();
    };
    const ariaLabel = React.useMemo(() => {
        const vegOptionLabel = vegOption === components_DietFilterToggle_types.VegOptionsType.VEG
            ? ACCESSIBILITY_LABEL.VEG
            : ACCESSIBILITY_LABEL.VEG_EGG;
        if (type === components_DietFilterToggle_types.DietType.VEG) {
            return isSelected
                ? jsUtils.format(ACCESSIBILITY_LABEL.DISABLE_VEG, vegOptionLabel)
                : ACCESSIBILITY_LABEL.ENABLE_VEG;
        }
        if (type === components_DietFilterToggle_types.DietType.NON_VEG) {
            return isSelected
                ? ACCESSIBILITY_LABEL.DISABLE_NON_VEG
                : ACCESSIBILITY_LABEL.ENABLE_NON_VEG;
        }
        return "";
    }, [isSelected, type, vegOption]);
    return (React__default.default.createElement(Container, { checked: isSelected, hasMoreOptions: hasMoreOptions, vegOption: vegOption, ref: containerRef },
        React__default.default.createElement(SliderWrapper, null,
            React__default.default.createElement(Input, { type: "checkbox", "aria-checked": isSelected, "aria-label": ariaLabel, checked: isSelected, onChange: onChangeHandler, id: type }),
            React__default.default.createElement(Slider, { checked: isSelected, type: type },
                React__default.default.createElement(ToggleIcon, { checked: isSelected, vegOption: vegOption },
                    React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: IconName })))),
        hasMoreOptions && isSelected && (React__default.default.createElement(MoreOptionsContainer, { onClick: moreOptionsOpenHandler },
            React__default.default.createElement(Separator, null),
            React__default.default.createElement(SpriteIconWeb$1.SpriteIconWeb, { style: { height: "14px" }, iconName: "chevronDown12", fillColor: "text_Med_Emphasis" }))),
        showMoreOptions && (React__default.default.createElement(Dropdown.Dropdown, { handleClose: moreOptionsCloseHandler, top: dropdownPosition[0], left: dropdownPosition[1], root: dropDownRoot, width: dropDownWidth, hasCustomPadding: true, dropDownPadding: {
                top: theme.spacing.small,
                bottom: theme.spacing.small,
                left: theme.spacing.medium,
                right: theme.spacing.medium,
            }, radios: {
                name: "veg-filter",
                value: vegOption,
                orientation: "rtl",
                spaceBetweenItems: "empty",
                items: showOnlyVeg ? VEG_OPTIONS : VEG_EGG_OPTIONS,
                onChange: moreOptionsOnChangeHandler,
            }, showCta: false }))));
};
var DietFilterToggle$1 = React.memo(DietFilterToggle);

exports.DietFilterToggle = DietFilterToggle$1;
//# sourceMappingURL=index.js.map
